import React from 'react';

export default function GaugeCard({ value = 0, max = 100, label = 'Doluluk', sub, color }) {
  const pct     = Math.min(100, Math.max(0, value));
  const level   = pct >= 80 ? 'critical' : pct >= 60 ? 'high' : pct >= 30 ? 'normal' : 'low';
  const clr     = color || (level === 'critical' ? 'var(--red)' : level === 'high' ? 'var(--yellow)' : level === 'normal' ? 'var(--accent)' : 'var(--green)');
  const levelTR = { critical:'Kritik', high:'Yüksek', normal:'Normal', low:'Düşük' };

  // SVG arc parametreleri
  const r    = 54;
  const cx   = 70;
  const cy   = 70;
  const circ = Math.PI * r; // yarım çember
  const dash = (pct / 100) * circ;

  return (
    <div className="card" style={{ textAlign:'center' }}>
      <div style={{ fontSize:11, textTransform:'uppercase', letterSpacing:'0.08em', color:'var(--text3)', marginBottom:12, fontFamily:'var(--font-display)' }}>
        {label}
      </div>
      <div style={{ position:'relative', display:'inline-block', width:140, height:80 }}>
        <svg width="140" height="80" viewBox="0 0 140 80">
          {/* Arkaplan yay */}
          <path
            d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
            fill="none" stroke="var(--border2)" strokeWidth="14" strokeLinecap="round"
          />
          {/* Değer yayı */}
          <path
            d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
            fill="none" stroke={clr} strokeWidth="14" strokeLinecap="round"
            strokeDasharray={`${dash} ${circ}`}
            style={{ transition:'stroke-dasharray 0.8s ease' }}
          />
        </svg>
        {/* Yüzde yazısı */}
        <div style={{ position:'absolute', bottom:0, left:0, right:0, textAlign:'center' }}>
          <div style={{ fontSize:24, fontFamily:'var(--font-display)', fontWeight:800, color:clr, lineHeight:1 }}>
            %{pct}
          </div>
        </div>
      </div>
      <div style={{ fontSize:13, color:'var(--text2)', marginTop:8 }}>
        {sub && <span>{sub} | </span>}
        <span style={{ color:clr, fontWeight:600 }}>{levelTR[level]}</span>
      </div>
    </div>
  );
}
